import KendoBarcode from '../KendoBarcode'
import KendoQRCode from '../KendoQRCode'

let KendoBarcodesInstaller = class {
    static install(Vue) {
        Vue.component(KendoBarcode.name, KendoBarcode)
        Vue.component(KendoQRCode.name, KendoQRCode)
    }
}

export default KendoBarcodesInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoBarcodesInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-barcodes-vue-wrapper/src/kendo-barcodes-installer/index.js